import React from "react"
import { HourReportWorkflow } from "../../api"
import AdminOwnHoursReviewSettings from "./AdminOwnHoursReviewSettings"
import HourReportingRolesSettings from "./HourReportingRolesSettings"
import HourReportWorkflowSettings from "./HourReportWorkflowSettings"
import { canUpdateHourReportSettings } from "../../api/hour-report-settings"

type OrgHourReportSettingsProps = {
  workflow: HourReportWorkflow
  canUpdateWorkflow: boolean
  canUpdateAdminSelfReview: boolean
}

const OrgHourReportSettings = (props: OrgHourReportSettingsProps) => {
  const [workflowPreview, setWorkflowPreview] = React.useState<HourReportWorkflow | null>(null)
  const workflow = workflowPreview ?? props.workflow
  const requiresApproval = workflow === HourReportWorkflow.Approval || workflow === HourReportWorkflow.CheckAndApproval

  const canUpdateSettings = canUpdateHourReportSettings({
    canUpdateWorkflow: props.canUpdateWorkflow,
    canUpdateAdminSelfReview: props.canUpdateAdminSelfReview,
  })

  if (!canUpdateSettings) {
    return null
  }

  return (
    <>
      <HourReportWorkflowSettings onWorkflowPreviewChange={setWorkflowPreview} />
      {workflow && <AdminOwnHoursReviewSettings workflow={workflow} />}
      {requiresApproval && <HourReportingRolesSettings />}
    </>
  )
}

export default OrgHourReportSettings
